import { IApplicationState } from '../../types/redux';

export function getEstimationFiltersHash(state: IApplicationState) {
  const dealType = state.page.dealType;

  return state.estimation[dealType].filtersHash;
}
